<template>
  <div class="rates-additional-info">
    <p v-for="(r, i) in row" :key="i">
      {{ r.rateData && r.rateData.rate && r.rateData.rate.comment }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'CalcRatesTableCellComment',
  props: {
    row: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellComment.vue